<template>
    <div class="signup-popup__wrapper" v-if="is_open">
        <div class="signup-popup">
            <a href="#" class="signup-popup__close" @click="close">
                <span class="inline-fa">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
                </span>
            </a>
            
            <h2 class="signup-popup__heading">
                WE THINK YOU WOULD BE A GOOD MEMBER OF OUR EXCLUSIVE CLUB
            </h2>

            <h3 class="signup-popup__body">
                Join the club now and get instant access to our members only area
                full of amazing venue and course inspiration, not forgetting the
                potential to play some of the most exclusive courses money can't buy.
            </h3>

            <div class="signup-popup__form mt-5">
                <div class="signup-popup__form-row">
                    <b-form-input
                        class="tb-form-field signup-popup__form-field"
                        type="text"
                        v-model="form.first_name"
                        placeholder="First Name"
                        required>
                    </b-form-input>

                    <b-form-input
                        class="tb-form-field signup-popup__form-field"
                        type="text"
                        v-model="form.last_name"
                        placeholder="Second Name"
                        required>
                    </b-form-input>
                </div>


                <div class="signup-popup__form-row mt-3">
                    <b-form-input
                        class="tb-form-field signup-popup__form-field"
                        type="email"
                        v-model="form.email"
                        placeholder="Email"
                        required>
                    </b-form-input>

                    <b-form-input
                        class="tb-form-field signup-popup__form-field"
                        type="text"
                        v-model="form.phone_number"
                        placeholder="Phone Number"
                        required>
                    </b-form-input>
                </div>

                <div class="signup-popup__form-row mt-3">
                    <alt-checkbox :initialvalue="form.agree" @box-checked="(x) => form.agree = x" required>
                        Please tick if you agree with our privacy terms. We guarantee your information will not be shared.
                    </alt-checkbox>

<!--                    <b-form-checkbox-->
<!--                        class="signup-popup__form-checkbox"-->
<!--                        v-model="form.agree">-->
<!--                        Please tick if you agree with our privacy terms. We guarantee your information will not be shared.-->
<!--                    </b-form-checkbox>-->
                </div>

                <b-button type="submit" variant="primary" class="signup-popup__form-button signup-popup__form-button--gold mt-5"
                    @click.prevent="submit">
                    I'd love the opportunity to play exclusive courses
                </b-button>

                <h3 class="mt-3">
                    Or
                </h3>

                <b-button type="submit" variant="primary" class="signup-popup__form-button signup-popup__form-button--blue mt-2"
                    @click.prevent="close">
                    I'm not interested and just want to go to my event
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>

import inviteRepository from "@/repository/invites";
import AltCheckbox from "@/components/AltCheckbox";

export default {
    components: {
        AltCheckbox
    },

    props: ['firstname', 'lastname', 'email', 'eventid', 'inviteid'],

    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                event_id: '',
                invite_id: '',
                agree: false
            },
            is_open: true,
        }
    },

    computed: {

    },

    methods: {
        submit() {
            console.log(this.form);

            if (!this.form.agree) {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Form Errors',
                    text: 'You must agree with our privacy terms to sign up',
                    duration: 30000,
                    width: '500px'
                });

                return;
            }

            if (!this.form.email) {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Form Errors',
                    text: 'The email field is required.',
                    duration: 30000,
                    width: '500px'
                });

                return;
            }

            if (!this.form.first_name || !this.form.last_name) {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Form Errors',
                    text: 'Your full name is required.',
                    duration: 30000,
                    width: '500px'
                });

                return;
            }

            inviteRepository.subscribe(this.form).then(res => {
                this.$notify({
                    group: 'main',
                    type: 'success',
                    title: 'Success',
                    text: 'You have successfully signed up.',
                    duration: 30000,
                    width: '500px'
                });

                this.close();
            }).catch(error => {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Error',
                    text: 'Signup failed. Please try again.',
                    duration: 30000,
                    width: '500px'
                });
            });
        },

        close() {
            this.is_open = false;
            document.body.classList.remove('no-scroll')
        }
    },

    mounted() {
        this.form.first_name = this.firstname;
        this.form.last_name = this.lastname;
        this.form.email = this.email;
        this.form.event_id = this.eventid;
        this.form.invite_id = this.inviteid;

        document.body.classList.add('no-scroll');
    }
}
</script>

<style scoped lang="scss">
    .signup-popup {
        background-color: $color-white;
        margin: 0 auto;
        max-width: 1000px;
        padding: 60px 20px;
        text-align: center;
        position: relative;
        color: $color-dark-blue;

        @include media-breakpoint-up(md) {
            margin: 100px auto 0 auto;
            border-radius: 30px;
            padding: 50px;
        }

        &__wrapper {
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-y: auto;
            background-color: rgba(0, 0, 0, .7);

            @include media-breakpoint-up(md) {
                padding: 10px;
            }
        }

        &__close {
            position: absolute;
            top: 20px;
            right: 30px;
            color: $color-light-blue;
            @include font-h3;
        }

        &__heading {
            color: $color-light-blue;
            margin-bottom: 2rem;
            letter-spacing: 8px;
            line-height: 1.1;

            @include media-breakpoint-up(md) {
                margin-top: 50px;
            }
        }

        &__body {
            letter-spacing: 2px;
            color: $color-dark-blue;
            line-height: 1.1;
        }

        &__form-row {
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            @include media-breakpoint-up(md) {
                flex-direction: row;
                padding: 0 50px;
            }
        }

        &__form-field {
            border: 1px solid $color-light-blue;
            @include font-h3;
            padding: 30px 20px;
            color: $color-dark-blue!important;
            width: 100%;
            text-align: center;

            @include media-breakpoint-up(md) {
                width: 49%;
            }

            &:hover,
            &:focus {
                border: 1px solid $color-light-blue;
                outline: none;
            }

            &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: $color-dark-blue!important;
                opacity: 1; /* Firefox */
                text-align: center;
            }

            &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: $color-dark-blue!important;
                text-align: center;
            }

            &::-ms-input-placeholder { /* Microsoft Edge */
                color: $color-dark-blue!important;
                text-align: center;
            }
        }

        &__form-checkbox {
            @include font-small;
        }

        &__form-button {
            background-color: transparent;
            border-radius: 30px;
            padding: 10px 20px;

            &:focus {
                outline: none;
            }

            &--blue {
                border: 1px solid $color-light-blue;
                color: $color-light-blue;

                &:hover {
                    color: $color-white;
                    background-color: $color-light-blue;
                    border: 1px solid $color-light-blue;
                }
            }

            &--gold {
                border: 1px solid $color-gold;
                color: $color-gold;

                &:hover {
                    color: $color-white;
                    background-color: $color-gold;
                    border: 1px solid $color-gold;
                }
            }
        }
    }
</style>